import vue from "vue";
import localForage from "localforage";

export default {
    SET_TITLE: (state, title) => {
        state.title = title;
    },
    SET_INDICATIONS: async (state, payload) => {
        if(!payload.items) {
            await localForage.setItem('indications',_.cloneDeep(payload.indications));
            if(payload.version) {
                await localForage.setItem('indications-version', payload.version);
            }
            vue.set(state, 'indications', payload.indications);
        }
        else vue.set(state, 'indications', payload.items);

        //state.indications = state.indications.splice(0, state.indications.length)
        //state.indications = _.cloneDeep(indications);

    },
    SET_INDICATION: (state, indication) => {
        state.indication = indication;
    },
    SET_STATUS: (state, status) => {
        state.status = status;
    },
    SET_INDICATIONS_TO_EDIT: (state, indicationsToEdit) => {
        state.indicationsToEdit = indicationsToEdit;
    },
    SET_TOTAL: (state, total) =>{
        state.total = total
    },
}